module.exports = __webpack_public_path__ + "img/expovina_06.ef7a4fa0.jpg";